import BaseMessageRecord from "../BaseMessageRecord";
import { httpMessageRecordDefaultAttributes, getInvalidHttpFields } from "../HTTPMessageRecord";

class MagentoMessageRecord extends BaseMessageRecord({
  ...httpMessageRecordDefaultAttributes,
  displayType: "magento"
}) {}

MagentoMessageRecord.getInvalidFields = getInvalidHttpFields;

export default MagentoMessageRecord;
